var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infobanner"},[_c('img',{attrs:{"src":_vm.resolve_img_url(_vm.url),"alt":""}}),_c('div',{staticClass:"infobanner__info"},[_vm._v(" "+_vm._s(_vm.info)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }